module.exports = __webpack_public_path__ + "img/baipei4.f801f71d.jpg";